import { render, staticRenderFns } from "./SMTP.vue?vue&type=template&id=4b58da9a&scoped=true&"
import script from "./SMTP.vue?vue&type=script&lang=js&"
export * from "./SMTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58da9a",
  null
  
)

export default component.exports